import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import JavaOutlinedSvg from "@ant-design/icons-svg/es/asn/JavaOutlined";
import AntdIcon from "../components/AntdIcon";
var JavaOutlined = function JavaOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: JavaOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  JavaOutlined.displayName = 'JavaOutlined';
}
export default /*#__PURE__*/React.forwardRef(JavaOutlined);